export default __webpack_public_path__ + "static/media/ppoSlider3.e9d3cb6a.png";